/* CloudPricingCalculator.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { MarketplaceBillingCycle as BillingCycleValues } from '@atlassian/mpac-types/graphql-gateway-types';
import React, { useState } from 'react';
import { calculateMonthlyAppCost, getPricingTier } from '../../PricingTab.utils';
import { getTierCeiling } from './CloudPricingCalculator.utils';
import PricingDisplaySection from './PricingDisplaySection';
import UserInputSection from './UserInputSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _6 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}._sp8tpxbi{padding-left:var(--ds-space-200,1pc)}._axwipxbi{padding-right:var(--ds-space-200,1pc)}}";
const _5 = "._1yt4xy5q{padding:var(--ds-space-400,2pc)}";
const _4 = "._1bah1yb4{justify-content:space-between}";
const _3 = "._2lx2vrvc{flex-direction:row}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._n7zl7v06{border-bottom:1px solid var(--ds-border)}";
const PricingCalculatorContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_n7zl7v06 _1e0c1txw _2lx2vrvc _1bah1yb4 _1yt4xy5q _na0i1bp4 _sp8tpxbi _axwipxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingCalculatorContainer.displayName = 'PricingCalculatorContainer';
}
const CloudPricingCalculator = _ref2 => {
  let {
    pricingItems,
    currency,
    billingCycle,
    onBillingCycleToggle,
    onPricingCalculatorInstallCTAClick,
    compatibleProduct
  } = _ref2;
  const firstTierCeiling = getTierCeiling(pricingItems[0]);
  const [userCount, setUserCount] = useState(firstTierCeiling);
  const amount = billingCycle === BillingCycleValues.Monthly ? calculateMonthlyAppCost(pricingItems, userCount) : getPricingTier(pricingItems, userCount).amount;
  const lastTierCeiling = getTierCeiling(pricingItems[pricingItems.length - 1]);
  const handleUserCountChange = changedUserCount => {
    setUserCount(changedUserCount);
  };
  return /*#__PURE__*/_jsxs(PricingCalculatorContainer, {
    children: [/*#__PURE__*/_jsx(UserInputSection, {
      userCount: userCount,
      onUserCountChange: handleUserCountChange,
      onBillingCycleToggle: onBillingCycleToggle,
      billingCycle: billingCycle,
      compatibleProduct: compatibleProduct
    }), /*#__PURE__*/_jsx(PricingDisplaySection, {
      userCount: userCount,
      appAmount: amount,
      currency: currency,
      billingCycle: billingCycle,
      annualPricingTier: getPricingTier(pricingItems, userCount),
      onPricingCalculatorInstallCTAClick: onPricingCalculatorInstallCTAClick,
      lastTierCeiling: lastTierCeiling
    })]
  });
};
export default CloudPricingCalculator;